export default __webpack_public_path__ + "static/media/zabinji2 pc done.bb9c6809.png";